'use client';

import { useSession } from 'next-auth/react';
import { useState } from 'react';
import { AvailableLoadsTable } from '@/app/shared/landing/pages/available-loads/available-loads-table';
import { CustomerBidModal } from '@/app/shared/customer-bid-modal';
import { CustomerBookModal } from '@/app/shared/customer-book-modal';
import { CustomerLoadboardDetailsModal } from '@/app/shared/customer-loadboard-modal/details-modal';
import type { PublicShipment } from '@/server/api';

type AvailableLoadsWorkspaceProps = {
  isLanding?: boolean;
};

export default function AvailableLoadsWorkspace({
  isLanding = false,
}: AvailableLoadsWorkspaceProps = {}) {
  const { data: session } = useSession();
  const [selectedLoad, setSelectedLoad] = useState<PublicShipment | null>(null);
  const [viewedLoad, setViewedLoad] = useState<PublicShipment | null>(null);
  const [isBidModalOpen, setIsBidModalOpen] = useState(false);
  const [isBookModalOpen, setIsBookModalOpen] = useState(false);
  const [refreshKey, setRefreshKey] = useState(0);

  const canBidOrBook = Boolean(session?.user);

  const handleBidClick = (load: PublicShipment) => {
    setSelectedLoad(load);
    setIsBidModalOpen(true);
  };

  const handleBookClick = (load: PublicShipment) => {
    setSelectedLoad(load);
    setIsBookModalOpen(true);
  };

  const handleBidSubmitted = () => {
    setIsBidModalOpen(false);
    setSelectedLoad(null);
    setRefreshKey((prev) => prev + 1);
  };

  const handleBookSubmitted = () => {
    setIsBookModalOpen(false);
    setSelectedLoad(null);
    setRefreshKey((prev) => prev + 1);
  };

  return (
    <div
      className={
        isLanding
          ? 'available-loads-landing-root min-w-0'
          : 'light-ship-smart-root available-loads-dashboard-root min-w-0 space-y-4 !bg-transparent pb-8 pt-1'
      }
    >
      <AvailableLoadsTable
        key={refreshKey}
        context="dashboard"
        onBidClick={canBidOrBook ? handleBidClick : undefined}
        onBookClick={canBidOrBook ? handleBookClick : undefined}
        onViewClick={!isLanding ? setViewedLoad : undefined}
      />

      {!isLanding && viewedLoad ? (
        <CustomerLoadboardDetailsModal
          load={viewedLoad}
          isOpen
          onClose={() => setViewedLoad(null)}
        />
      ) : null}

      {canBidOrBook && (
        <>
          <CustomerBidModal
            load={selectedLoad}
            isOpen={isBidModalOpen}
            onClose={() => {
              setIsBidModalOpen(false);
              setSelectedLoad(null);
            }}
            onBidSubmitted={handleBidSubmitted}
          />
          <CustomerBookModal
            load={selectedLoad}
            isOpen={isBookModalOpen}
            onClose={() => {
              setIsBookModalOpen(false);
              setSelectedLoad(null);
            }}
            onBookSubmitted={handleBookSubmitted}
          />
        </>
      )}
    </div>
  );
}
